<template>
  <v-row wrap v-if="cuti">
    <v-col cols="12">
      <m-card title="Detail Ketidakhadiran">
        <v-row wrap>
          <v-col cols="12">
            <v-list>
              <m-list-tile-info
                label="Kategori"
                :value="cuti.cuti_kategori.nama"
              />
              <m-list-tile-info label="Nama" :value="cuti.users.nama" />
              <m-list-tile-info label="Status Ajuan" >
                <template v-slot:value>
                  <div>
                    <v-chip small outlined :color="mStatus[cuti.k_status]['color']">
                      {{ mStatus[cuti.k_status]['label'] }}
                    </v-chip>
                  </div>
                </template>
              </m-list-tile-info>
              <m-list-tile-info
                label="Jumlah Ajuan (Hari)"
                :value="cuti.jumlah"
              />
              <m-list-tile-info
                label="Keterangan"
                :value="pVal(cuti, 'keterangan')"
              />
              <v-subheader class="font-weight-bold primary--text">
                Lampiran
              </v-subheader>
              <p class="ml-4" v-if="cuti.lampiran">
                <v-icon color="primary" small>mdi-file</v-icon>
                <a class="ml-2" :href="cuti.lampiran" target="_blank">{{
                  pVal(cuti, "lampiran")
                }}</a>
              </p>
            </v-list>
          </v-col>
        </v-row>
      </m-card>
    </v-col>
  </v-row>
</template>
<script>
import { STATUS_AJUAN } from "../../kategori/const";

export default {
  components: {},
  data() {
    return {
      cuti: null,
      mStatus: STATUS_AJUAN,
    };
  },
  computed: {},
  activated() {
    this.load();
  },
  methods: {
    load() {
      this.$store
        .dispatch("cuti/detail", {
          organisasi_id: this.organisasi_id,
          cuti_id: this.$route.params.cuti_id
        })
        .then(res => {
          this.page = res.data;
          this.cuti = res.data;
        })
        .catch(e => e);
    },
    close() {
      this.$router.push({
        name: "cuti"
      });
    }
  }
};
</script>
